import { observer } from "mobx-react-lite"
import { IndividualDashboard } from "../components/IndividualDashboard"
import { OrganizationDashboard } from "../components/OrganizationDashboard"
import { TeamDashboard } from "../components/TeamDashboard"
import { useViewStore } from "../stores/StoreContext"

export const HomePage = observer(() => {
  const viewStore = useViewStore()

  // Render dashboard based on selected view
  if (viewStore.isOrganizationView) {
    return <OrganizationDashboard />
  }

  if (viewStore.isGroupView) {
    return <TeamDashboard />
  }

  if (viewStore.isIndividualView) {
    return <IndividualDashboard />
  }

  return <OrganizationDashboard />
})
